
define('lib/AppRouter',['require','backbone','marionette','Config'],function (require) {
    var Backbone = require('backbone');
    var Marionette = require('marionette');
    var Config = require('Config');

    return Marionette.AppRouter.extend({

        blankThemeAllowedRoutes : [
            'clientBookingsCancel', // /#client/bookings/cancel/
            'clientBookingsReschedule', // /#client/bookings/reschedule/
            'signIn', 'signOut', 'profile', 'remind', 'password', // /#client/profile
            'clientBookings', // /#client/bookings/type/upcoming
            'onlineMeetingView', //online-meeting/client/
            'onlineMeetingProvider', //online-meeting/provider/
            'clientBookingsResult', //client/bookings(/ids/:ids)(/status/:status)(/cart_id/:cart_id)(/system/:system)(/)
            'pay', //
            'viewCampaign',
            'viewPush'
        ],


        onRoute: function(name, path, args) {
            Backbone.Wreqr.radio.vent.trigger('navigation', 'navigate:to', {
                name: name,
                path: path,
                args: args
            });

            var config = Config.getInstance();

            if(config.getOption('filter_blank_routes') && this.blankThemeAllowedRoutes.indexOf(name) === -1){
                console.warn('Route ' + name + ' not allowed');

                var redirect_url = config.getOption('redirect_url');
                if (redirect_url) {
                    window.location = config.getOption('redirect_url', '/');
                } else {
                    window.location = '/v2/404'
                }
            }
        }
    });
});
